export type Airline = {
  iata: string;
  title: string;
};

export enum AirlineIconSizeEnum {
  small,
  default,
  large,
}
